<div class="mep-btn-small">
	@if (links.length > 0) {
		<a mat-icon-button color="primary" (click)="openNavigateDialog()">
			<mat-icon matTooltip="{{ 'mep.components.project-data.navigation' | translate }}">directions</mat-icon>
		</a>
	}
</div>
